<template>
  <div class="welcome-box">
    <!-- <Editor v-model="article.content" />
    <h1 v-if="roles.includes('/user/edit')">首页</h1>
    <div class="dashboard-text">userInfo: {{ userInfo }}</div>
    <div class="dashboard-text">name: {{ userInfo.username }}</div>
    <div class="dashboard-text">imgUrl: {{ imageUrl }}</div>
    <div class="dashboard-text">
      roles: <span v-for="role in roles" :key="role">{{ role }}<br /></span>
    </div> -->
    <!-- <div class="welcome">

    </div> -->
    <img class="welcome" src="../../assets/welcome.jpg" alt="">
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import { mapGetters } from "vuex";
import { getAuth } from "@/api/index";
import treeTransfer from "el-tree-transfer"; // 引入
export default {
  components: { treeTransfer, Editor },
  name: "Dashboard",
  computed: {
    ...mapGetters(["userInfo", "roles", "imageUrl"]),
  },
  data() {
    return {
      article: {
        content: "",
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.welcome-box {
  width: 100%;
  height: 100%;
  .welcome {
    display: block;
    width: 100%;
    height: 100%;
    // background: url('../../assets/welcome.jpg') center center;
    object-fit: cover;
  }
}

.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
